import type { ISearchEntity } from "~/feature/search/type";

export const findMatchingEntity = (
  entities: ISearchEntity[],
  query: string
): ISearchEntity | null => {
  const queryLower = query.trim().toLowerCase();
  if (!queryLower) return null;

  return (
    entities.find(
      (e) =>
        e.searchQuery.toLowerCase().includes(queryLower) ||
        queryLower.includes(e.searchQuery.toLowerCase())
    ) ?? null
  );
};
